export const coordinateValueTest = (value: string) => /[°*|:]/g.test(value);
